/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */

// 费用类型
export const ORDER_PRICE_TYPE = {
  1: { label: '项目服务费', value: 1 },
  2: { label: '平台服务费', value: 2 },
  3: { label: '商务服务费', value: 3 },
  4: { label: '技术服务费', value: 4 }
};
// 支付方式
export const PAY_TYPE = {
  1: { label: '线上支付', value: 1 },
  2: { label: '线下支付', value: 2 }
};
